<template>
  <div>
    <div v-for="(option, index) in stepOptions" :key="option.id">
      <div class="qn-header-container">
        <div class="d-flex align-items-center">
          <span
            class="fa-stack qn-header-container__icon-container cursor-pointer"
            @click="emit('on-selected-option', option)"
          >
            <em
              class="fas fa-circle fa-stack-2x"
              :class="{
                'qn-header-container--active': option.active,
                'qn-header-container--completed': option.completed,
                'qn-header-container--disabled':
                  !option.active && !option.completed,
              }"
            />
            <span
              class="fa-stack-1x"
              :class="{
                'text-white': option.active,
                'gray-19': !option.active && !option.completed,
              }"
            >
              <em v-if="option.completed" class="fas fa-check text-white" />
              <b v-else>{{ index + 1 }}</b>
            </span>
          </span>
          <span
            class="font-14 qn-header-container__title"
            :class="{
              'qn-header-container__title--active': option.active,
              'qn-header-container__title--completed': option.completed,
              'qn-header-container__title--disabled':
                !option.active && !option.completed,
            }"
          >
            {{ option.title }}
          </span>
        </div>
        <div
          v-if="index !== stepOptions.length - 1"
          class="qn-header-container__spacer-line"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import requestFormSteps from '@/utils/constants/requestFormSteps';

export default {
  name: 'NavigationHeader',
  props: {
    currentStepId: {
      type: Number,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    stepOptions() {
      const active = this.steps.find((x) => x.id === this.currentStepId);
      return this.steps.map((step, index) => ({
        id: step.id,
        title: step.title,
        active: step.id === active?.id,
        completed: this.isConfirmationViewStep
          ? true
          : index < this.steps.indexOf(active),
      }));
    },
    isConfirmationViewStep() {
      return this.currentStepId === requestFormSteps.REQUEST_CONFIRMATION;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.qn-header-container {
  width: 100%;
  &--active {
    color: map-get($colors, 'orange-light-2');
  }
  &--completed {
    color: map-get($colors, 'primary-4');
  }
  &--disabled {
    color: map-get($colors, 'gray-17');
  }

  &__icon-container {
    cursor: pointer;
    margin-right: 8px;
  }

  &__title {
    font-weight: 500;
    margin-left: 10px;
    width: 300px;
    &--active {
      color: map-get($colors, 'dark-blue');
    }
    &--completed {
      color: map-get($colors, 'primary-4');
    }
    &--disabled {
      color: map-get($colors, 'gray-19');
    }
  }

  &__spacer-line {
    border-left: 2px solid map-get($colors, 'gray-23');
    height: 40px;
    margin: 5px 1.1em;
  }
}

@media (max-width: 991px) {
  .qn-header-container {
    &__spacer-line {
      height: 20px;
    }
    &__title {
      width: 250px;
    }
  }
}
</style>
